import { NgModule } from '@angular/core';
import { BgModule } from './bg/bg.module';
import { ColorModule } from './color/color.module';
var ThemeModule = /** @class */ (function () {
    function ThemeModule() {
    }
    ThemeModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        BgModule,
                        ColorModule
                    ],
                    exports: [BgModule, ColorModule]
                },] },
    ];
    /** @nocollapse */
    ThemeModule.ctorParameters = function () { return []; };
    return ThemeModule;
}());
export { ThemeModule };
export * from './bg/bg.module';
export * from './color/color.module';
//# sourceMappingURL=theme.module.js.map